import { formatDateExtended } from 'helper/utils'
import validate from 'helper/validate.js'

interface ParamsValidate {
  transferValue: string
  pixKey: string
  pixType: string
}

export const validateData = ({
  transferValue,
  pixKey,
  pixType,
}: ParamsValidate): Record<string, string> | null => {
  if (!transferValue || Number(transferValue) === 0) {
    return { amount: 'Campo obrigatório' }
  }

  if (!pixKey) return { pix: 'Campo obrigatório' }
  if (!pixType) return { pixType: 'Campo obrigatório' }

  const pixValidators: Record<string, (value: string) => boolean> = {
    CPF: (value) => !!validate.numbers.cpf(value) === true,
    CNPJ: (value) => !!validate.numbers.cnpj(value) === true,
    PHONE: (value) => !!validate.numbers.cellphonePix(value) === true,
    EMAIL: (value) => !!validate.string.email(value) === true,
  }

  const validator = pixValidators[pixType]

  if (validator && !validator(pixKey)) {
    const typeLabels: Record<string, string> = {
      CPF: 'CPF',
      CNPJ: 'CNPJ',
      PHONE: 'Telefone',
      EMAIL: 'E-mail',
    }
    return { pix: `${typeLabels[pixType]} inválido` }
  }

  return null
}

const pixTypes = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  PHONE: 'Telefone',
  EMAIL: 'E-mail',
  EVP: 'Aleatória',
}

const status = {
  SCHEDULED: { label: 'Agendado', color: '#2C76E4', background: '#2C76E41A' },
  REQUESTED: { label: 'Solicitado', color: '#2C76E4', background: '#2C76E41A' },
  DONE: { label: 'Realizado', color: '#00CD52', background: '#00CD521A' },
  REFUSED: { label: 'Recusado', color: '#FDAB3D', background: '#FDAB3D1A' },
  CANCELLED: { label: 'Cancelado', color: '#FDAB3D', background: '#FDAB3D1A' },
}

const waitStatus = {
  label: 'Aguardando Autorização',
  color: '#2C76E4',
  background: '#2C76E41A',
}

export const formatExtract = (extract: any) => {
  return extract.map((item: any) => {
    const rawValue = Number(item.value)
    const isCredit = rawValue > 0
    const value = Math.abs(rawValue)
    const signedValue = isCredit ? value : -value

    const isFee = item.type?.includes('FEE')
    const itemStatus = isFee ? 'DONE' : item.status

    return {
      value: {
        label: signedValue.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
        value: signedValue,
      },
      date: formatDateExtended(new Date(item.date)),
      pixType: pixTypes[item.pixKeyType as keyof typeof pixTypes],
      pixKey: item.pixKey,
      id: item.transferId,
      bank: item.bankName,
      status: status[itemStatus as keyof typeof status] || waitStatus,
      receipt: item.statement,
    }
  })
}

export const pixTypeOptions = [
  { label: 'CPF', value: 'CPF' },
  { label: 'CNPJ', value: 'CNPJ' },
  { label: 'Telefone', value: 'PHONE' },
  { label: 'E-mail', value: 'EMAIL' },
  { label: 'Aleatória', value: 'EVP' },
  { label: 'Taxa', value: 'FEE' },
]
export const statusOptions = [
  { label: 'Agendado', value: 'SCHEDULED' },
  { label: 'Solicitado', value: 'REQUESTED' },
  { label: 'Realizado', value: 'DONE' },
  { label: 'Recusado', value: 'REFUSED' },
  { label: 'Cancelado', value: 'CANCELLED' },
]
